import React, { useContext, useEffect, useState } from "react";

export const API_URL= `https://www.omdbapi.com/?apikey=${process.env.REACT_APP_API_KEY}`

const AppContext = React.createContext();



const AppProvider =({children})=>{

    const [isLoading,setIsLoding]=useState(true);
    const [movie,setMovie] = useState([]);
    const [isError,setIsError]=useState({show:"false",msg:""})
    const [query,setQuery]=useState('avenger')

    const getMovies = async(url)=>{
        setIsLoding(true)
        try{
             const res= await fetch(url);
             const data=await res.json();
             console.log(data);
             if(data.Response==='True'){
                setIsLoding(false)
                setIsError({
                    show:false,
                    msg:data.Error
                 })
                setMovie(data.Search)
             }else{
                 setIsError({
                    show:true,
                    msg:data.Error
                 })
             }
        }catch(error){
            console.log(error)
        }
    }
    useEffect(()=>{
       let timerOut= setTimeout(()=>{
            getMovies(`${API_URL}&s=${query}`);
        },400);

        return ()=>clearTimeout(timerOut)
    
    },[query])
    return <AppContext.Provider value={{isLoading,isError,movie,query,setQuery}}>{children}</AppContext.Provider>
}

const useGlobalContext=()=>{
    return useContext(AppContext)
}

export{AppContext,AppProvider,useGlobalContext}